import { useTranslation } from 'react-i18next';
import { LayoutDashboard } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function DashboardSection() {
  const { t } = useTranslation('help');
  const s = 'sections.dashboard';

  return (
    <GuideSection
      id="dashboard"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={LayoutDashboard}
    >
      <GuideSubSection title={t(`${s}.summaryCards.title`)}>
        <p>{t(`${s}.summaryCards.p1`)}</p>
        <p>{t(`${s}.summaryCards.p2`)}</p>
        <p>{t(`${s}.summaryCards.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.recentTickets.title`)}>
        <p>{t(`${s}.recentTickets.p1`)}</p>
        <p>{t(`${s}.recentTickets.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.slaOverview.title`)}>
        <p>{t(`${s}.slaOverview.p1`)}</p>
        <p>{t(`${s}.slaOverview.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.activityFeed.title`)}>
        <p>{t(`${s}.activityFeed.p1`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
